<template>
    <div>
         <Modal
            v-model="relevanceShow"
            
            title="关联客户 "
            :mask-closable="false"
            :closable="false">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
                <FormItem label="客户手机号" prop="phone">
                    <AutoComplete
                        v-model="formValidate.phone"
                        :data="AutoCompleteData"
                        @on-search="handlechange"
                        @on-select="handleSelect"
                        placeholder="请输入客户手机号"></AutoComplete>
                </FormItem>
                <FormItem label="关联客户说明"  prop="desc">
                    <Input v-model="formValidate.desc" type="textarea" :maxlength="500" :autosize="{minRows: 2,maxRows: 5}" placeholder="500字内"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="handleCancel">取消</Button>
                <Button type="primary" size="large"  @click="handleSubmit('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:"CRM_relevance",
    props:["relevanceShow","customerInfoDetailId"],
    data(){
        return{
            formValidate:{
                phone:"",
                desc:""
            },
            customerInfo:{},
            AutoCompleteData: [],
            getData: [],
            ruleValidate:{
                'phone': [
                    { required: true, max:11,  message: '请输入客户手机号', trigger: 'blur' }
                ],
                'desc': [
                    { required: true, max:500, message: '请输入关联客户说明', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        handlechange (value) {
            this.formValidate.phone = value.substring(0,11)
            this.apiGetCustomerPhoneInfo(value.substring(0,11))
        },
        handleSelect(value){
            this.formValidate.phone = value.substring(0,11)
        },
        apiGetCustomerPhoneInfo(phone){
            let params = {
                phone:phone,
                member_id:this.customerInfo.id,
            }
            serve.fetchGet(api.getCustomerPhoneInfo,params).then(data => {
                console.log(data)
                let AutoCompleteData = []
                this.getData = data.members
                if(data.members.length){
                    for(let item of data.members){
                        let name = item.phone +' '+ item.name
                        AutoCompleteData.push(name)
                    }
                }else{
                    AutoCompleteData = []
                }
                this.AutoCompleteData = AutoCompleteData
            }).catch((error)=>{
                this.formValidate.phone = ''
                this.AutoCompleteData = []
                this.$Message.error('无关联客户，请重新输入');
                if(error.response){
                    this.$Message.error(error.response.data.message);
                }
            })
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.apiAddRelineshipsCustome()
                    
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        apiAddRelineshipsCustome(){
            if(this.getData.length == 0){
                this.$Message.error('无关联客户');
                return
            }
            let params = {
                member_id:this.customerInfo.id,
                phone:this.customerInfo.phone,
                name:this.customerInfo.name,
                relevance_member_id:this.getData[0].id,
                relevance_phone:this.getData[0].phone,
                relevance_name:this.getData[0].name,
                explain:this.formValidate.desc,
            }
            console.log(params)
            if(params.phone == params.relevance_phone){
                this.$Message.error('不能关联自己');
                return
            }
            serve.fetchPost(api.addRelineshipsCustome,params).then(data => {
                console.log(data)
                this.$Message.success('添加成功');
                this.$emit("relevanceEven", false,true)
            }).catch((error)=>{
                if(error.response){
                    this.$Message.error(error.response.data.message);
                }
            })
        },
        handleCancel () {
            this.$emit("relevanceEven", false)
        },
        //获取客户基本信息
        apigetMemberDetail(){
            serve.fetchGet(api.myMemberGetMemberDetail+"/"+this.customerInfoDetailId,{}).then(data => {
                console.log('获取客户基本信息',data)
                let detail = data.data
                this.customerInfo = detail
            }).catch((error)=>{
                // this.$Message.error(error.response.data.message);
            })
        }
    },
    watch:{
        relevanceShow(val){
            if(val){
                this.formValidate.phone = ''
                this.formValidate.desc = ''
                this.$refs.formValidate.resetFields()
                this.apigetMemberDetail()
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_relevance.vue